import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

import { PlacesExist } from "@/features/my/places/exist";

export const Route = createFileRoute("/(member)/(protected)/my/places/exist")({
  component: PlacesExist,
  validateSearch: z.object({
    redirect: z.string().optional(),
  }),
});
